import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions } from 'ducks/calibrations';
import React from 'react';
import { useSelector } from 'react-redux';
import { serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';

const Component = props => {
    const { measurement } = props;
    const { closeDrawer } = props;

    const formSchema = [
        {
            accept: 'image/jpg,image/png',
            label: 'File\x2a (max 2Mb)',
            name: 'picture',
            type: 'file',
            validate: [validators.required]
        },
        {
            label: 'Value\x2a',
            name: 'value',
            type: 'text',
            validate: [validators.required]
        },
        {
            label: 'Date\x2a',
            name: 'date',
            type: 'dateTime',
            validate: [validators.required]
        }
    ];

    const submitting = useSelector(state => state.calibrations.submitting);

    const create = actions.useCreate();
    const onSubmit = values => {
        const data = {
            ...serializeForm(values, formSchema),
            ...{ measurement_id: measurement.id }
        };
        create(data, closeDrawer);
    };

    return (
        <FormViewer label="Add Calibration">
            <Form
                formSchema={formSchema}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default Component;
